<!-- 手机设置 -->
 <template>
  <div class="phone-container">
    <div class="hint-view">
      <img src="@/assets/image/hint-image.png" alt="" />
      <label>
        绑定手机可以用于安全身份验证、找回密码等重要操作，如有问题，请联系客服咨询
      </label>
    </div>
    <div class="phone-container-view">
      <!-- 存在用户手机号 -->
      <div class="user-phone" v-if="changePhomeType == 0">
        <img
          src="@/assets/newImage/sub-suc-ico.BB4Wd5EJ.png"
          alt=""
        />
        <div style="margin-top: 20px">已绑定 177****2161</div>
        <el-button
          type="primary"
          style="margin-top: 20px"
          @click="changePhomeClick(1)"
          >更换手机</el-button
        >
      </div>
      <div class="input-phone" v-else>
        <div class="input-item">
          <div style="padding-right: 100px">已绑定手机:</div>
          <div>177****2161</div>
        </div>
        <div class="input-item" style="margin-top: 40px">
          <div style="padding-right: 90px">短信验证码：</div>
          <el-input
            v-model="input"
            placeholder="请输入手机号"
            style="width: 300px"
          ></el-input>
          <span class="suffix" style="margin-left: -90px; z-index: 999"
            >获取验证码</span
          >
        </div>
        <div class="input-item" style="margin-top: 40px">
          <div style="padding-right: 90px"></div>
          <el-button
            type="primary"
            style="margin-top: 20px"
            @click="changePhomeClick(0)"
            >下一步</el-button
          >
        </div>
      </div>
      <div
        style="
          height: 1.5px;
          background-color: #e0e0e0;
          width: 50%;
          margin-top: 100px;
        "
      ></div>
      <div class="bottom-content">
        <div class="bottom-title">
          1、您的手机绑定之后，即可享受手机登录、找回密码等服务
        </div>
        <div class="bottom-label">
          2、若您的手机可正常使用但无法接收到验证码短信，可能是由于网络异常造成的，请稍后重新尝试操作。
        </div>
        <div class="bottom-label">
          3、如果您的手机已经无法正常使用，请提供用户名，手机号，身份证号，点击联系平台<a
            class="link"
            >在线客服</a
          >
        </div>
        <div class="bottom-label">
          4、设置登录密码后可以使用手机和登录密码进行帐号登录
        </div>
      </div>
    </div>
  </div>
</template>
 
 <script>
export default {
   data() {
      return {
         changePhomeType:1,
          input: ''
      }
   },
   methods: {
      changePhomeClick(vl) {
         this. changePhomeType = vl;
         
    },
  },
};

</script>
 
 <style lang="scss" scoped>
.hint-view {
  margin: 0px 30px;
  height: 40px;
  color: rgb(169, 83, 0);
  background: rgb(255, 244, 219);
  display: flex;
  align-items: center;
  font-size: 12px;
  color: rgb(169, 83, 0);
  padding: 0px 20px;
  border-radius: 10px;
  img {
    width: 28px;
    height: 28px;
    margin-right: 10px;
  }
}

.phone-container {
  background-color: white;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 30px;
  .phone-container-view {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 100px;
    .user-phone {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 240px;
        height: 146px;
      }
      color: #1f1f1f;
      font-size: 20px;
      font-weight: 700;
    }
    .input-phone {
      padding: 30px 450px;
      display: flex;
      flex-direction: column;
      align-items: self-start;
      width: 100%;
      .input-item {
        display: flex;
        align-items: center;
      }
    }
    .bottom-content {
      width: 100%;
      display: flex;
      flex-direction: column;
      padding: 30px 350px;

      .bottom-title {
        color: #000000e0;
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
      }
      .bottom-label {
        color: #000000a6;
        font-family: PingFang SC, sans-serif;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
      }
    }
  }
  .link {
    padding-left: 10px;
    color: -webkit-link;
    cursor: pointer;
    text-decoration: underline;
    color: #488eff !important;
  }
}
.suffix {
  margin-left: -75px; /* 与输入框间隔 */
  z-index: 99;
  color: #488eff;
}
</style>